export enum UpdateAction {
    Created,
    Changed,
    Deleted
}